export default __webpack_public_path__ + "static/media/panTech1.06538c14.png";